import React from 'react'
import SliderGallery from '../components/SliderGallery'

const BeigeGallery = () => {

  const galleryImages = [
    // {
    //   img: "/assets/Multi-Family - Beige.jpg",
    //   alt: 'Dec-Tec membrane in various applications and settings 1'
    // }
  ]

  return (
    <div>
      <SliderGallery
        title="Beige"
        para1="Simple, warm, and clean – Beige is all the above. Similar in design to solid grey, it is a warmer design that compliments brown and tan tones and pairs well with brick, stucco, and siding."
        noteText="We currently do not have any gallery pictures for this membrane. If you have any pictures of this membrane, please send them in to us!"
        galleryImages={galleryImages}
        previouslink="/products/membranes/classic-line"
      />
    </div>
  )
}

export default BeigeGallery
